import * as filestack from "filestack-js";
import { PickerDisplayMode } from "filestack-js";
import { FilestackUploadedFile } from "src/pages/Welcome/hooks/useCreateQuickPost";
import { appConfig } from "src/appConfig";

// Keep a reference to any existing picker to properly close it
let currentPickerInstance: filestack.PickerInstance | null = null;

const getFilestackClient = (): filestack.Client => {
  return filestack.init(appConfig.platform.filestackApiKey);
};

type FilestackPickerProps = {
  remainingNumberOfFiles: number;
  setRemainingNumberOfFiles: React.Dispatch<React.SetStateAction<number>>;
  setUploadedFiles: React.Dispatch<
    React.SetStateAction<FilestackUploadedFile[]>
  >;
};

export const getFilestackPicker = (
  props: FilestackPickerProps,
): filestack.PickerInstance => {
  const {
    remainingNumberOfFiles,
    setUploadedFiles,
    setRemainingNumberOfFiles,
  } = props;

  // Close the existing picker if one exists
  if (currentPickerInstance) {
    try {
      currentPickerInstance.close();
    } catch (e) {
      console.warn("Error closing previous picker:", e);
    }
  }

  // First clean the container
  const container = document.getElementById("droppane");
  if (container) {
    container.innerHTML = "";
  }

  // Create a fresh picker instance with the current remainingNumberOfFiles
  const picker = getFilestackClient().picker({
    accept: [".jpg", ".jpeg", ".png"],
    container: "#droppane",
    displayMode: PickerDisplayMode.inline,
    fromSources: [
      "local_file_system",
      "unsplash",
      "url",
      "googledrive",
      "dropbox",
      "onedrive",
      "box",
    ],
    transformations: {
      crop: false,
      circle: false,
      rotate: false,
    },
    maxFiles: remainingNumberOfFiles > 0 ? remainingNumberOfFiles : 1,
    maxSize: 10485760, // 10MB limit
    onFileUploadStarted: () => {},
    onUploadDone: (res) => {
      const imageFiles: FilestackUploadedFile[] = res.filesUploaded.map(
        (image) => ({
          name: image.filename,
          url: image.url,
          contentType: "image",
        }),
      );
      setUploadedFiles((prev) => [...prev, ...imageFiles]);
      setRemainingNumberOfFiles((prev) => prev - imageFiles.length);
      picker.close();
    },
    rootId: "filepicker",
    uploadInBackground: false,
  });

  // Store the current picker instance
  currentPickerInstance = picker;

  return picker;
};
